import { makeAutoObservable } from "mobx";
import { SearchObject } from "app/common/Model/SearchObject";
import { pagingMarketingVoucher, getMarketingVoucherById, getAllMarketingVoucher, saveMarketingVoucher, deleteMarketingVoucher } from 'app/services/MarketingVoucherService';
import { checkSearchObject } from "app/common/LocalFunction";
import { toast } from "react-toastify";
import { MarketingVoucher } from "app/common/Model/MarketingVoucher";

export default class MarketingVoucherStore {
    listAllMarketingVoucher = [];
    searchMarketingVoucher = new SearchObject();
    pageMarketingVoucher = null;
    selectedMarketingVoucher = null;
    openFormCreateOrEdit = false;
    openConfirmDeleteMarketingVoucher = false;

    constructor() {
        makeAutoObservable(this);
    }

    getAllMarketingVoucher = () => {
        if (this.listAllMarketingVoucher?.length === 0) {
            getAllMarketingVoucher()
                .then(({ data }) => this.listAllMarketingVoucher = data)
                .catch((error) => {
                    console.error(error);
                    toast.error("Lấy dữ liệu có lỗi");
                });
        }
    }

    pagingMarketingVoucher = () => {
        pagingMarketingVoucher(this.searchMarketingVoucher)
            .then(({ data }) => {
                this.pageMarketingVoucher = data;
            })
            .catch((error) => {
                console.error(error);
                toast.error("Lấy dữ liệu có lỗi");
            })
    }

    handleChangeFormSearch = (searchMarketingVoucher) => {
        this.searchMarketingVoucher = checkSearchObject(this.searchMarketingVoucher, searchMarketingVoucher);
        this.pagingMarketingVoucher();
    }

    handleOpenFormCreateOrEdit = (marketingId) => {
        const handleFormat = (value) => {
            if(value || value === 0) {
                return `${value}`
            }

            return ''
        }

        if (Boolean(marketingId)) {
            getMarketingVoucherById(marketingId)
                .then(({ data }) => {
                    this.selectedMarketingVoucher = {
                        ...data,
                        reducedPercent:handleFormat(data?.reducedPercent),
                        reducedMaxAmount:handleFormat(data?.reducedMaxAmount),
                        minCondition:handleFormat(data?.minCondition),
                        reducedAmount:handleFormat(data?.reducedAmount),
                        numberUsed:handleFormat(data?.numberUsed),
                    };
                    this.openFormCreateOrEdit = true;
                })
                .catch((error) => {
                    console.error(error);
                    toast.error("Lấy dữ liệu có lỗi");
                })
        } else {
            this.selectedMarketingVoucher = new MarketingVoucher();
            this.openFormCreateOrEdit = true;
        }
    }

    saveMarketingVoucher = (voucher) => {
        return saveMarketingVoucher(voucher).then(() => {
            this.selectedMarketingVoucher = null;
            toast.success("Lưu bản ghi thành công!");
            this.handleClosePopup();
            this.pagingMarketingVoucher();
        })
            .catch(error => {
                console.error(error);
                toast.error("Lưu bảng ghi có lỗi");
            })
    }

    handleDeleteMarketingVoucher = (voucher) => {
        this.selectedMarketingVoucher = { id: voucher?.id };
        this.openConfirmDeleteMarketingVoucher = true;
    }

    handleConfirmDeleteMarketingVoucher = () => deleteMarketingVoucher(this?.selectedMarketingVoucher?.id)
        .then(() => {
            if (this.searchMarketingVoucher.pageIndex > 1 && this.pageMarketingVoucher.content.length === 1) {
                this.searchMarketingVoucher.pageIndex -= 1;
            }
            toast.success("Xóa bản ghi thành công!")
            this.handleClosePopup();
            this.pagingMarketingVoucher();
        })
        .catch(err => {
            console.error(err);
            toast.error("Xóa bản ghi có lỗi");
        })

    handleClosePopup = () => {
        this.openFormCreateOrEdit = false;
        this.openConfirmDeleteMarketingVoucher = false;
    }

    resetStore = () => {
        this.searchMarketingVoucher = new SearchObject();
        this.pageMarketingVoucher = null;
        this.selectedMarketingVoucher = null;
        this.openFormCreateOrEdit = false;
        this.openConfirmDeleteMarketingVoucher = false;
    }
}